import { render, staticRenderFns } from "./CardSimple.vue?vue&type=template&id=0fc688be"
import script from "./CardSimple.vue?vue&type=script&lang=js"
export * from "./CardSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports